import React, { useContext, useState, useEffect } from "react";
import "../../AppointmentHistory/Appointments.scss";
import CustomModal from "../../UI Component/Modal/ModalCustom";
import {
  filterRecords,
  filters,
  getDateByRanges,
} from "./constantsDoctorMyPaitent";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import useWindowSize from "../../../Hooks/useWindowSize";
import StaffContext from "../../Staff/StaffContext";
import DoctorContext from "../../ClinicComponents/ClinicWrapper/DoctorContext";

export default function FilterPatientsModal(props) {
  const {
    show,
    handleClose,
    date,
    appointmentStatus,
    status,
    prescriptionStatus,
    start,
    end,
    onFilterSuccess,
    onResetFilter,
    selectedAppointmentType,
    mobileFilterData,
    doctorNameList,
    doctor_selected,
    temp_doctor_selected,
    selectedFilterStatus,
    setSelectedFilterStatus,
    resetFilterData,
    setResetFilterData,
  } = props;
  const staff_context = useContext(DoctorContext);
  const size = useWindowSize();
  const [sideMenu, setSideMenu] = useState("doctorNameStatus");
  const [filterData, setFilterData] = useState({
    appointmentStatus: "",
    doctorNameStatus: "",
  });

  useEffect(() => {
    let list = [
      { name: "All", value: "all", doctor_id: doctor_selected },
      ...staff_context.selectedDoctor,
    ];
    let temp;
    temp = filters;
    temp.doctorNameStatus = list;
  }, [staff_context.selectedDoctor]);

  useEffect(() => {
    setSelectedFilterStatus({
      appointmentStatus: selectedFilterStatus["appointmentStatus"]
        ? selectedFilterStatus["appointmentStatus"]
        : "all",
      doctorNameStatus: selectedFilterStatus["doctorNameStatus"]
        ? selectedFilterStatus["doctorNameStatus"]
        : "all",
    });
  }, []);

  const onHandleMethodCall = (item) => {
    const sideBar = filters.sideMenu.find((filter) => filter.value == sideMenu);
    setFilterData({ ...filterData, [sideBar.value]: item });
    setSelectedFilterStatus({
      ...selectedFilterStatus,
      [sideBar.value]: item.value,
    });
  };

  return (
    <CustomModal show={show && size.width < 1024 ? show : false}>
      <div className="d-flex col-sm-12 d-lg-none appointment-filter-header-div">
        <div className="appointment-filter-header-tittle-div">Filters</div>
        <div className="ml-auto" onClick={() => handleClose()}>
          Close
          <i className="fa fa-close pl-1" aria-hidden="true"></i>
        </div>
      </div>

      <div className={`appointment-filter-body-div d-flex `}>
        <div className={`appointment-filter-body-sidebar-div col-sm-6 p-0`}>
          {filters.sideMenu.map((item, i) => {
            return (
              <div
                className={`${sideMenu === item.value ? "active" : ""}`}
                key={i}
                onClick={() => {
                  setSideMenu(item.value);
                }}
              >
                {item.name}
              </div>
            );
          })}
        </div>
        <div className="col-sm-6">
          {filters[sideMenu].map((item, i) => {
            return (
              <div
                className="appointment-filter-body-right-div"
                key={i}
                onClick={() => onHandleMethodCall(item)}
              >
                <i
                  className={`fa fa-check mr-1 check-icon-filter ${
                    selectedFilterStatus[sideMenu] === item.value
                      ? "activeTab"
                      : ""
                  }`}
                  aria-hidden="true"
                ></i>
                {item.name}
              </div>
            );
          })}
        </div>
      </div>
      <div className="d-flex col-sm-12 appointment-date-range-buttons-div p-2">
        <a
          className="ml-auto appointment-date-range-reset"
          onClick={() => {
            onResetFilter(filterData);
          }}
        >
          Reset All
        </a>
        <button
          className="ml-2 btn-primary appointment-date-range-apply"
          onClick={() => onFilterSuccess(filterData)}
        >
          Apply
        </button>
      </div>
    </CustomModal>
  );
}
